import { buttonIconWidth, buttonPadding } from "@1js/acui-button";
import { buttonBorderWidth } from "@1js/acui-common";

export const ribbonOverflowSetItemContainerClass = "ribbonOverflowItem";

export const overflowButtonWidth =
  buttonIconWidth + 2 * buttonPadding + 2 * buttonBorderWidth;
